import { createAction, props } from '@ngrx/store';
import {
  Customer,
  Role,
  ServiceLocation,
  Site,
  Supplier,
  WoPermission,
  Locale,
} from '@iss/libs/graphql';

import { CountriesConfig } from './app-context.types';

export const appContextActions = {
  permissionsLoaded: createAction('[App Context | GraphQL API] Permissions loaded', props<{ readonly permissions: readonly WoPermission[]; }>()),
  permissionsLoading: createAction('[App Context | GraphQL API] Permissions loading'),
  permissionsLoadingFailure: createAction('[App Context | GraphQL API] Permissions loading failure', props<{ httpCode?: number }>()),

  countriesLoaded: createAction('[App Context | GraphQL API] Countries loaded', props<{ readonly countries: CountriesConfig; }>()),
  countriesLoading: createAction('[App Context | GraphQL API] Countries loading'),
  countriesLoadingFailure: createAction('[App Context | GraphQL API] Countries loading failure', props<{ httpCode?: number }>()),
  resetCountries: createAction('[App Context] Reset countries'),

  onlyOneCustomerLoaded: createAction('[App Context | GraphQL API] Only one customer loaded', props<{ readonly customer: Customer['id'] | null }>()),
  onlyOneCustomerLoading: createAction('[App Context | GraphQL API] Only one customer loading'),
  onlyOneCustomerLoadingFailure: createAction('[App Context | GraphQL API] Only one customer loading failure', props<{ httpCode?: number }>()),

  onlyOneSiteLoaded: createAction('[App Context | GraphQL API] Only one site loaded', props<{ readonly site: Site['id'] | null }>()),
  onlyOneSiteLoading: createAction('[App Context | GraphQL API] Only one site loading'),
  onlyOneSiteLoadingFailure: createAction('[App Context | GraphQL API] Only one site loading failure', props<{ httpCode?: number }>()),

  onlyOneServiceLocationLoaded: createAction('[App Context | GraphQL API] Only one service location loaded', props<{ readonly serviceLocation: ServiceLocation['id'] | null }>()),
  onlyOneServiceLocationLoading: createAction('[App Context | GraphQL API] Only one service location loading'),
  onlyOneServiceLocationLoadingFailure: createAction('[App Context | GraphQL API] Only one service location loading failure', props<{ httpCode?: number }>()),

  mobileDeviceDetected: createAction('[App Context] Mobile device detected', props<{ isMobile: boolean }>()),
  roleSelected: createAction('[App Context] Role selected', props<{ readonly role: Role | null; }>()),
  countrySelected: createAction('[App Context] Country selected', props<{ readonly country: Locale | null; }>()),
  customerSelected: createAction('[App Context] Customer Selected', props<{ readonly customer: Customer['id'] | 'ALL' | null }>()),
  siteSelected: createAction('[App Context] Site Selected', props<{ readonly site: Site['id'] | 'ALL' | null }>()),
  serviceLocationSelected: createAction('[App Context] Service Location Selected', props<{ readonly serviceLocation: ServiceLocation['id'] | 'ALL' | null }>()),
  supplierSelected: createAction('[App Context] Supplier Selected', props<{ readonly supplier: Supplier['id'] | null }>()),
  contextAccepted: createAction('[App Context] Context accepted', props<{ readonly redirect: string; }>()),
};
